

const RouteNames = {
  Error: 'error',
  Callback: 'auth-code/callback',
  Logout: 'logout',
  SessionExpired: 'session-expired',
  SessionTimeout: 'session/time-out',
  UnAuthorized: 'access-denied',
  Home: 'home',
  ScheduleProcedure: 'schedule-procedure',
  EditScheduleProcedure: 'modify-schedule-procedure',
  Directory: 'directory',
  Batch:'batch',
  Settings: 'settings',
  ManageWaste : 'manage-waste',
  ManageProducts: 'manage-products',
  ManagePONumbers: 'manage-po-numbers',
  ManageComponents: 'manage-components',
  ManageProcedures: 'manage-procedures',
  PatientClassMaster: 'patient-class-master',
  ManageAlerts: 'manage-alerts',
  HL7Alerts: 'hl7-alerts',
  ManufacturerOrderAlerts:'manufacturer-order-alerts',
  Theranostic:'theranostic',
  KitConfiguration: 'kit-configuration',
  SiteMaster: 'site-master',
  RouteMaster: 'route-master',
  TrackingCodesMaster: 'tracking-codes-master',
  Preferences: 'preferences',
  UserManagement: 'user-management',
  Sharing: 'sharing',
  PeripheralConfig: 'peripheral-config',
  SafetracConfig: 'safetrac-config',
  VendorBarcodeSetup: 'vendor-barcode-setup',
  Documents: 'documents',
  Training: 'training',
  ReceiveShipment:'receive-shipment',
  ConfigTest:'config-test',
  ManageInstruments :'manage-instruments',
  HPHistory: 'hp-history',
  ManageSurveyGroups:'surveyGroups',
  ManageInventory: 'manage-inventory',
  OutgoingReturnBox : 'outgoingReturnBox',
  RequestReport:'idnReportsView',
  DocumentRepository:'document-repository',
  DigiradReports:'digirad-reports',
  DownloadReports:'download-reports',
  Invoice:'invoice',
  KitPreparation : 'kitPreparation',
  okta:'',
  AccessDenied:'access-denied',
  NoLicense:'no-license',
  ManufacturerPortal: 'manufacturer-portal',
  WrittenDirective: 'written-directive',
  AssayDose: 'assay-dose',

};

export enum MasterRoutes {
  Okta = '',
  Module = '',
  Home = 'home',
  Inventory = 'inventory',
  Schedule = 'schedule',
  Waste = 'waste',
  HealthPhysics = 'health-physics',
  Reports = 'reports',
  Alerts = 'alerts',
  Settings = 'settings',
  ManufacturerPortal = 'manufacturer-portal',

}

export const HomeRoutes = {
  Home: {
    Name: RouteNames.Home,
    Url: MasterRoutes.Module + '/' + RouteNames.Home,
  },
};

export const HealthPhysicsRoutes = {
  ManageInstruments: {
    Name: RouteNames.ManageInstruments,
    Url: MasterRoutes.HealthPhysics + '/' + RouteNames.ManageInstruments,
  },
  HPHistory: {
    Name: RouteNames.HPHistory,
    Url: MasterRoutes.HealthPhysics + '/' + RouteNames.HPHistory,
  },
  ManageOtherTasks: {
    Name:RouteNames.ConfigTest,
    Url:MasterRoutes.Inventory + '/' + RouteNames.ConfigTest,
  },
  ManageSurveyGroups: {
    Name:RouteNames.ManageSurveyGroups,
    Url:MasterRoutes.HealthPhysics + '/' + RouteNames.ManageSurveyGroups,
  },
};

export const ModuleRoutes = {
  Dashboard: {
    Name: MasterRoutes.Home,
    Url: MasterRoutes.Module + '/' + MasterRoutes.Home
  },
  Settings: {
    Name: MasterRoutes.Settings,
    Url: MasterRoutes.Module + '/' + MasterRoutes.Settings
  },
  Alerts: {
    Name: MasterRoutes.Alerts,
    Url: MasterRoutes.Module + '/' + MasterRoutes.Alerts
  },
  HealthPhysics: {
    Name: MasterRoutes.HealthPhysics,
    Url: MasterRoutes.Module + '/' + MasterRoutes.HealthPhysics
  },
  Reports: {
    Name: MasterRoutes.Reports,
    Url: MasterRoutes.Module + '/' + MasterRoutes.Reports
  }
}

export const ErrorRoutes = {
  Error: {
    Name: RouteNames.Error,
    Url: RouteNames.Error,
  },
};

export const ReportsRoutes = {
  RequestReport: {
    Name: RouteNames.RequestReport,
    Url: MasterRoutes.Reports + '/' + RouteNames.RequestReport,
  },
  DownloadReports: {
    Name: RouteNames.DownloadReports,
    Url: MasterRoutes.Reports + '/' + RouteNames.DownloadReports,
  },
  Invoice:{
    Name: RouteNames.Invoice,
    Url: MasterRoutes.Reports + '/' + RouteNames.Invoice,
  },
  DocumentRepository: {
    Name: RouteNames.DocumentRepository,
    Url: MasterRoutes.Reports + '/' + RouteNames.DocumentRepository,
  },
  DigiradReports: {
    Name: RouteNames.DigiradReports,
    Url: MasterRoutes.Reports + '/' + RouteNames.DigiradReports,
  },
}

export const ScheduleRoutes = {
  ScheduleProcedure: {
    Name: RouteNames.ScheduleProcedure,
    Url: MasterRoutes.Schedule + '/' + RouteNames.ScheduleProcedure,
  },
  EditScheduleProcedure: {
    Name: RouteNames.EditScheduleProcedure,
    Url: MasterRoutes.Schedule + '/' + RouteNames.EditScheduleProcedure,
  },
  Directory: {
    Name: RouteNames.Directory,
    Url: MasterRoutes.Schedule + '/' + RouteNames.Directory,
  },
    BatchSchedule: {
    Name: RouteNames.Batch,
    Url: MasterRoutes.Schedule + '/' + RouteNames.Batch,
  },
  WrittenDrective: {
    Name: RouteNames.WrittenDirective,
    Url: MasterRoutes.Schedule + '/' + RouteNames.WrittenDirective,
  }
}
export const WasteRoutes={
  ManageWaste : {
    Name : RouteNames.ManageWaste,
    Url: MasterRoutes.Waste + '/' + RouteNames.ManageWaste,
  },
  OutgoingReturnBox : {
    Name : RouteNames.OutgoingReturnBox,
    Url: MasterRoutes.Waste + '/' + RouteNames.OutgoingReturnBox,
  }
}
export const SettingsRoutes = {

  ManageProducts: {
    Name: RouteNames.ManageProducts,
    Url: MasterRoutes.Settings + '/' + RouteNames.ManageProducts,
  },
  ManagePONumbers: {
    Name: RouteNames.ManagePONumbers,
    Url: MasterRoutes.Settings + '/' + RouteNames.ManagePONumbers,
  },
  ManageComponents: {
    Name: RouteNames.ManageComponents,
    Url: MasterRoutes.Settings + '/' + RouteNames.ManageComponents,
  },
  ManageProcedures: {
    Name: RouteNames.ManageProcedures,
    Url: MasterRoutes.Settings + '/' + RouteNames.ManageProcedures,
  },
  PatientClassMaster: {
    Name: RouteNames.PatientClassMaster,
    Url: MasterRoutes.Settings + '/' + RouteNames.PatientClassMaster,
  },
  KitConfiguration: {
    Name: RouteNames.KitConfiguration,
    Url: MasterRoutes.Settings + '/' + RouteNames.KitConfiguration,
  },
  SiteMaster: {
    Name: RouteNames.SiteMaster,
    Url: MasterRoutes.Settings + '/' + RouteNames.SiteMaster,
  },
  RouteMaster: {
    Name: RouteNames.RouteMaster,
    Url: MasterRoutes.Settings + '/' + RouteNames.RouteMaster,
  },
  TrackingCodesMaster: {
    Name: RouteNames.TrackingCodesMaster,
    Url: MasterRoutes.Settings + '/' + RouteNames.TrackingCodesMaster,
  },
  Preferences: {
    Name: RouteNames.Preferences,
    Url: MasterRoutes.Settings + '/' + RouteNames.Preferences,
  },
  UserManagement: {
    Name: RouteNames.UserManagement,
    Url: MasterRoutes.Settings + '/' + RouteNames.UserManagement,
  },
  Sharing: {
    Name: RouteNames.Sharing,
    Url: MasterRoutes.Settings + '/' + RouteNames.Sharing,
  },
  PeripheralConfig: {
    Name: RouteNames.PeripheralConfig,
    Url: MasterRoutes.Settings + '/' + RouteNames.PeripheralConfig,
  },
  SafetracConfig: {
    Name: RouteNames.SafetracConfig,
    Url: MasterRoutes.Settings + '/' + RouteNames.SafetracConfig,
  },
  VendorBarcodeSetup: {
    Name: RouteNames.VendorBarcodeSetup,
    Url: MasterRoutes.Settings + '/' + RouteNames.VendorBarcodeSetup,
  },
  Documents: {
    Name: RouteNames.Documents,
    Url: MasterRoutes.Settings + '/' + RouteNames.Documents,
  },
  Training: {
    Name: RouteNames.Training,
    Url: MasterRoutes.Settings + '/' + RouteNames.Training,
  },
};

export const AlertsRoutes = {
  ManageAlerts: {
    Name: RouteNames.ManageAlerts,
    Url: MasterRoutes.Alerts + '/' + RouteNames.ManageAlerts,
  },
  HL7Alerts: {
    Name: RouteNames.HL7Alerts,
    Url: MasterRoutes.Alerts + '/' + RouteNames.HL7Alerts,
  },
   ManufacturerOrderAlerts: {
    Name: RouteNames. ManufacturerOrderAlerts,
    Url: MasterRoutes.Alerts + '/' + RouteNames. ManufacturerOrderAlerts,
  },
  Theranostic: {
    Name: RouteNames.Theranostic,
    Url: MasterRoutes.Alerts + '/' + RouteNames.Theranostic,
  }
};

export const PermissionRoutes = {
  AccessDenied: {
    Name: RouteNames.AccessDenied,
    Url: MasterRoutes.Module + '/' + RouteNames.AccessDenied,
  },
  NoLicense:{
    Name: RouteNames.NoLicense,
    Url: MasterRoutes.Module + '/' + RouteNames.NoLicense,
  }
};

export const InventoryRoutes={
  ConfigTest:{
    Name:RouteNames.ConfigTest,
    Url:MasterRoutes.Inventory + '/' + RouteNames.ConfigTest,
  },
  ReceiveShipment:{
    Name:RouteNames.ReceiveShipment,
    Url:MasterRoutes.Inventory + '/' + RouteNames.ReceiveShipment,
  },
  ManageInventory:{
    Name:RouteNames.ManageInventory,
    Url:MasterRoutes.Inventory + '/' + RouteNames.ManageInventory,
  },
  KitPreparation:{
    Name:RouteNames.KitPreparation,
    Url: MasterRoutes.Inventory + '/' + RouteNames.KitPreparation,
  }
}

export const ManufacturerPortalRoutes = {
  ManufacturerPortal: {
    Name: RouteNames.ManufacturerPortal,
    Url: MasterRoutes.ManufacturerPortal,
  }
};

export const AssayDoseRoutes = {
  AssayDose: {
    Name: RouteNames.AssayDose,
    Url: MasterRoutes.Home + '/' + RouteNames.AssayDose,
  }  
};




